import PreAnestesicoEnum from '../enum/PreAnestesicoEnum'
import StatusCirurgiaEnum from '../enum/StatusCirurgiaEnum'
import TipoDocumentoUpload from '../enum/TipoDocumentoUpload'
import PesoDoPacienteEnum from '../enum/PesoDoPacienteEnum'
// eslint-disable-next-line import/no-cycle
import { CaixaCirurgica, MedicoPrescritor, SolicitacaoComorbidadesDoPaciente, TempoDeDoenca } from './SolicitacaoCirurgia'
import { CotacaoOperadorasExtraGrupo } from './CotacaoOperadorasExtraGrupo'
import StatusPrecificacaoOperadoraEnum from '../enum/StatusPrecificacaoOperadoraEnum'
import { IProtocoloTecnicaDeCirurgia, SolicitacaoOpme } from './protocolo/protocolo.interface'
import TipoPacienteEnum from '../enum/TipoPacienteEnum'
import { StatusDoProtocoloEnum } from './protocolo/status-do-protocolo.enum'
import { IDocumentoObrigatorio } from './documentacao-obrigatoria/documento-obrigatorio.interface'
import { IProtocoloJustificativaDoMedico } from './protocolo/protocolo-justificativa-do-medico.interface'
import ComplexidadeEnum from '../enum/ComplexidadeEnum'
import { ClassificacaoAsaEnum } from '../_'
import { AprovacoesSolicitacao } from './AgendamentoCirurgia'

export interface AgendamentoCirurgiaDisabled {
  disabled: boolean,
}

export interface ModalSolicitacaoCirurgia {
  showCid: boolean,
  showProcedimentoPrincipal: boolean,
  showProcedimentoAssociado: boolean,
  showQuantidade: boolean,
  showAssociadoQuantidade: boolean,
  showOpme: boolean,
  showOpmeFornecedor: boolean,
  showItensAutorizados: boolean,
  showItensAutorizadosClinica: boolean,
  showMotivoCancelamento: boolean,
  showProtocoloFornecedor: boolean,
  showEquipamento: boolean,
  showHospitalOpcoes: boolean,
  showSair: boolean,
  showGerenciar: boolean,
  showAlteracaoDataSolicitada: boolean,
  showAlteracaoDataSolicitadaClinica: boolean,
  showModalPendenciaProtocolo: boolean,
}

export interface Solicitacao {
  id: string,
  dataEnvio?: string,
  observacaoReservaSala: string | null,
  nomePaciente: string,
  pacienteNome?: string | null,
  hospitalId: string,
  dataNascimento: string | null,
  dataNascimentoTemp: string,
  idade: number | null,
  telefone: string,
  celular: string,
  email: string,
  convenio: string | null,
  convenioId?: string | null,
  convenioNome?: string | null,
  plano: string | null,
  carteirinha: string,
  carater: Carater | number | null,
  caraterTemp: string | null,
  justificativaDePrazo?: string,
  diagnosticoJustificativa: string,
  tipoProcedimentoTemp: string | null,
  tipoProcedimento: number | null,
  tipoInternacao: string | null,
  lateralidade: number | null,
  lateralidadeTemp: string | null,
  alergiaLatexTemp: string,
  alergiaLatex: number | boolean | null,
  alergiaContraste: string |boolean | null,
  marcapasso: boolean | null,
  testeCovid: boolean | null,
  reoperacao: boolean | null,
  tipoAnestesia: any,
  tipoAnestesiaTemp?: any,
  tipoRegraReserva?: string,
  outrasAlergias: boolean | null,
  especificarOutrasAlergias: string | null,
  precaucoes: Situacao | null,
  precaucoesTemp: string | null,
  medicamentosEspeciais: string,
  medicacaoContinua?: string,
  temMedicamentosEspeciais?: boolean | null,
  temMedicacaoContinua?: boolean | null,
  medEspeciaisTemp: string,
  usoQuimioTemp: string,
  temPrevisaoUsoQuimioterapico?: boolean | null,
  previsaoUsoQuimioterapico: string | null,
  especificarPrecaucoes: string,
  tempoCirurgia: number | null,
  diaria: number | null,
  honorarioMedico: number | null,
  honorarioMedicoDocumento: string | null,
  honorarioMedicoTemp: string | null,
  reservaUTI: {
    display: string,
    key: string,
  },
  convenioExigeCodificacaoOpme: boolean,
  reservaUtiTemp: string | null,
  opcaoDataPrevisto1: string | null,
  opcaoDataPrevisto2: string | null,
  opcaoDataPrevisto3: string | null,
  opcaoDataPrevisto1Temp: string | null,
  opcaoDataPrevisto2Temp: string | null,
  opcaoDataPrevisto3Temp: string | null,
  instrucaoData: string | null,
  dataAgendamentoVirtual: boolean,
  dataAgendamento: string,
  instrucaoDataPrevista: string,
  anestesiaDoHospital: string | boolean | null,
  anestesiaDoHospitalTemp: string | null,
  honorarioAnestesista: HonorarioAnestesista | null,
  honorarioAnestesistaDocumento: string | null,
  especificacaoExameIntraOperatorio: string,
  orientacaoPreparoPaciente: string,
  medicoSolicitanteId: string,
  files: any[],
  laudos: Laudo[],
  resumos: SolicitacaoResumoResponse[],
  cids: Cid[] | null,
  procedimento: Procedimento | null,
  procedimentosAssociados: Procedimento[] | null,
  opmes: OPME[] | null,
  equipamentos: Equipamento[] | null,
  caixasCirurgicas: CaixaCirurgica[],
  examesIntraOperatorios: ExamesIntraOperatorio | null,
  reservaHemocomponentes: ReservaHemocomponente,
  sexo: string | null,
  recemNascido: boolean | null,
  recemNascidoTemp: string | null,
  statusSituacao: string | null,
  codigoPrestador: string,
  medicoPrescritor?: MedicoPrescritor,
  medicoSolicitante: MedicoSolicitante,
  secretariaDoMedicoSolicitante: SecretariaDoMedicoSolicitante,
  nomeAnestesista: string,
  anestesistaCrm: string,
  anestesista: AnestesistaHospital | null,
  numeroAgendamento: string,
  protocoloOperadora: string,
  protocoloOPME: string,
  dataAutorizacaoNaOperadora: string | null,
  autorizadoStatus: number | null,
  observacao: string,
  situacao: Situacao,
  acoes: Acoes,
  hospitalRealizaCotacao: boolean | null,
  canceladoMotivo: CanceladoMotivo,
  cotacaoOperadorasExtraGrupo: CotacaoOperadorasExtraGrupo | null,
  elegivel: boolean | null,
  dataVerificacaoElegibilidade: string | null,
  erroVerificacaoElegibilidade: string | null,
  observacaoPreAnestesia: string | null,
  tipoAnestesiaPaciente?: string | null,
  viasAereasDificilAcesso: boolean | null,
  preAnestesico?: StatusPreAnestesico | null,
  statusAvaliacaoPreAnestesia: {
    display: string,
    key: string,
  },
  statusAguardandoOperadora: string,
  negociacaoParticularStatus: string | null,
  autorizacaoValidade: string | null,
  autorizacaoObservacao: string | null,
  numeroOrcamento: string | null,
  cnpjDoHospital?: string,
  medicoAnestesistaPreAvaliacaoNome: string,
  pacienteAptoParaAnestesia: boolean | null,
  pacienteUsaMarcaPasso: boolean | null,
  outrosTipoAnestesia: string | null,
  origem: string | Situacao | null,
  enviadaPor?: Situacao | null,
  auditada: boolean,
  auditadaObservacao?: string,
  salaCirurgicaNome: string,
  hospitalFazReservaDeSala?: boolean,
  naoSeraSincronizadaNoHisPorqueFoiCriadaAntesDoGoLive?: boolean,
  url?: string | null,
  urlNaoParticular?: string | null,
  opmeFornecedores: OpmeFornecedor[],
  etapa: {
    key: string,
    display: string,
  },
  localAtendimentoId: string | null,
  localAtendimentoNome: string | null,
  cpf: string,
  paciente: {
    id: string,
    nome: string,
    idade: number | string,
    cpf: string,
    rgh: string,
    tipoPaciente?: TipoPacienteEnum | null,
    rne?: string | null,
    passaporte?: string | null,
    paisId?: string | null,
    cpfResponsavel?: string | null,
    certidaoNascimentoLivro?: string | null,
    certidaoNascimentoFolha?: string | null,
    certidaoNascimentoTermo?: string | null,
    nomeSocial?: string | null,
    dataNascimento: string,
    recemNascido: string,
    sexo: string,
    peso: string,
    altura: string,
    telefone: string,
    celular: string,
    email: string,
    convenioId: string,
    convenioNome: string,
    planoId: string,
    planoNome: string,
    categoriaCoberturaVigente?: boolean,
    categoriaId: string,
    categoriaNome: string,
    tipoAcomodacao: string | Situacao,
    carteirinha: string,
    dataVerificacaoElegibilidade: string,
    elegivel: boolean | string,
  },
  historicoFamiliarHipertemiaMaligna: boolean | null,
  classificacaoAsa: ClassificacaoAsaEnum | null,
  observacaoComplementares: string | null,
  grupoOpmeDaSolicitacao: OpmeFornecedor[],
  hospitalTemStepNaAutorizacaoParaAtualizarQuantidadeAutorizada: boolean | null,
  diferencaDeAcomodacao?: boolean | null,
  temInstrumentadorExterno?: boolean | string,
  temEquipeMedica?: boolean | string,
  equipeCirurgica?: {
    conselhoTipo?: string,
    conselhoNumero?: string,
    medicoNome?: string,
    conselhoUf?: string,
  }[],
  temOpmeDoConsultorio?: boolean | null,
  instrumentadorExterno?: string,
  equipeMedica?: string,
  opmeDoConsultorio?: string,
  diariaUti?: number | null,
  temInternacaoDeVespera: boolean | string,
  internacaoDeVespera: string,
  temReservaHemocomponentesSimples: boolean | null,
  pesoDoPaciente: PesoDoPacienteEnum | null,
  tempoDeDoenca: TempoDeDoenca | null,
  farmacia: string | null,
  motivoCancelamentoDescricao?: string | null,
  hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos?: boolean | null,
  hospitalRealizaTriagemDuranteOPreAgendamento?: boolean,
  operadoraSenha?: string | null,
  operadoraQuantidadeDiasAutorizado?: string | null,
  operadoraSenhaProvisoria?: string | null,
  convenioParticular?: boolean | null,
  procedimentosInternacao: Procedimento[],
  hospitalInsereProcedimentosDeInternacao: boolean,
  outrasSolicitacoesNaoRealizadasDoPaciente?: any[],
  convenioUtilizaRoboDeAutorizacao?: boolean,
  roboAutorizacaoMotivoNegativa?: string | null
  roboAutorizacaoStatusDaAutorizacao?: string | null,
  temOpme?: boolean,
  autorizacaoDeveInformarProtocoloDaOperadora: boolean,
  configuracaoOpme: {
    fazCodificacaoDeOpme: boolean,
    codificacaoDeOpmeEhObrigatorio: boolean,
    fazPrecificacaoOperadora?: boolean,
    precificaValorUnitario: boolean,
    precificacaoValorUnitarioEhObrigatorio: boolean,
  }
  temPendenciaDePaciente?: boolean,
  temPendenciaDeMedico?: boolean,
  temPendenciaDePacientePais?: boolean,
  hospitalEConvenioUtilizamRoboDeAutorizacao?: boolean,
  hospital?: {
    fazReservaDeSala: boolean,
    hisTipo: string,
    hospitalInformaCotacaoDeOpmeNaAreaDeSuprimentos: boolean,
    hospitalInsereProcedimentosDeInternacao: boolean,
    id: string,
    nome: string,
    exigeNumeroReserva: boolean,
    hospitalFazConsultaCoberturaVigente?: boolean,
    tipoDeCoberturaVigente?: 'Categoria' | 'Procedimento',
    utilizaTipoAcomodacaoHospital?: boolean,
    hospitalGeraGuiaTissPeloFront?: boolean,
    hospitalFazOrcamentoAntesDoAgendamento?: boolean,
  },
  statusPrecificacaoOperadora?: {
    key: StatusPrecificacaoOperadoraEnum,
    display: string,
  } | null,
  temConsultaDePrecaucoesDoPaciente?: boolean,
  materiaisCotadosOpme?: any,
  procedimentosInternacaoOperadora?: any[],
  convenioEnviaProcedimentoInternacao?: boolean,
  convenioEnviaCodigoPrestadorSolicitante?: boolean,
  convenioEnviaCodigoUnicoMaterial?: boolean,
  codigoPrestadorSolicitante?: string,
  codigoUnicoMaterial?: string,
  centroCirurgico?: CentroCirurgico,
  tipoCentroCirurgico?: string,
  grupoDeOpme?: SolicitacaoGrupoOpme,
  protocoloDeCirurgia?: ProtocoloDeCirurgiaDaSolicitacao,
  utilizaAutorizacaoPos?: boolean,
  criadaComoOrcamentoParticularAvulso?: boolean,
  dataAutorizacaoNaOperadoraObrigatoria?: boolean,
  checklistDocumentosObrigatorios?: SolicitacaoChecklistDocumentosObrigatorios
  statusFidelizacao?: { key: string, display: string }
  categoriaDoPlanoParaFidelizacao?: string,
  registraProtocoloDeRecuperacaoPrecoce: boolean | null,
  utilizaAnalisePreAutorizacaoUrgencia?: boolean,
  utilizaAguardandoAutorizacaoUrgencia?: boolean,
  comorbidadesDoPaciente?: SolicitacaoComorbidadesDoPaciente[],
  convenioAssociadoNome?: string | null,
  planoAssociadoNome?: boolean | null,
  categoriaAssociadaNome?: boolean | null,
  classificacaoCirurgia?: string | null,
  templateMapaCirurgico?: any | null,
  pacienteEstaInternado?: boolean | null,
  numeroDoAtendimentoAoPacienteNoHospital?: string | null,
  justificativaTecnica?: string | null,
  numeroDoLeitoDoPacienteInternado?: string | null,

  confirmacaoCirurgiaMedico?: ConfirmacaoCirurgica | null;
  confirmacaoCirurgiaPaciente?: ConfirmacaoCirurgica | null;

  comorbidade?: string | null,
  medicacaoDapt?: string | null,
  funcaoRenal?: string | null,
  complexidade?: ComplexidadeEnum | null,
  motivoRecusaDoOrcamento?: string,
  principaisResultadosProvasDiagnosticas?: string | null,
  valorOrcamentoParticular?: number,
  orcamentoPagamento?: {
    id?: string,
    pagamentoId?: string,
    valor?: number,
    dataPagamento?: string,
    metodoPagamento?: string
  }
}

export interface ConfirmacaoCirurgica {
  respondidoEm?: string;
  criadoEm?: string;
  criadoPor?: string
  status: ConfirmacaoCirurgicaStatusEnum
}

export enum ConfirmacaoCirurgicaStatusEnum {
  naoEnviado = 'NaoEnviado',
  confirmado = 'Confirmado',
  recusado = 'Recusado',
  pendente = 'Pendente'
}

export interface SolicitacaoChecklistDocumentosObrigatorios {
  documentosObrigatorios: IDocumentoObrigatorio[];
  confirmaQueAnexouOsDocumentos: boolean;
}

export interface ProtocoloDeCirurgiaDaSolicitacao {
  protocoloDeCirurgiaId: string;
  statusDoProtocolo: string;
  status?: 'CriouSolicitacaoAPartirDoProtocolo' | 'AceitouSugestaoDaFinxDeSeguirOProtocolo' | 'RecusouSugestaoDaFinxDeSeguirOProtocolo';
  tecnicaDeCirurgiaId?: string;
  tecnicaDeCirurgia?: IProtocoloTecnicaDeCirurgia;
  medicoRecusouSeguirOProtocolo: boolean;
  kitDeOpmeId?: string;
  segueOProtocolo: StatusDoProtocoloEnum;
  justificativaMedico?: IProtocoloJustificativaDoMedico;
  justificativasMedico?: IProtocoloJustificativaDoMedico[];
  fidelizacao?: {
    observacaoDaPendenciaDeProtocolo: string;
    justificativaFidelizacao: string,
    sugestaoDeProtocolo: {
      protocoloId: string,
      tecnicaId?: string,
      kitId?: string,
    },
    criadoEm: string
  },
  regulacao?: {
    criadoEm: Date;
    observacaoParaFidelizacao: string;
    observacaoDaAnalise: string;
  }
}

export interface SolicitacaoGrupoOpme {
  id?: string;
  descricao?: string;
  opmes: SolicitacaoOpme[]
}

export interface ProcedimentoConfiguracaoOperadora {
  id: string,
  codigo: string,
  descricao: string,
}

export interface OpmeFornecedor {
  id: string,
  fornecedorNome1: string,
  fornecedorNome2: string,
  fornecedorNome3: string,
  opmes: OpmeFornecedores[],
}

export interface OpmeFornecedores {
  opme: any
  fornecedor1: any
  opmeId: string,
  codigo: string,
  termo: string,
  descricao: string,
  quantidade: number,
  particular?: boolean,
  medidaTamanho?: string,
  justificativa: string,
  protocolo: boolean,
  codigoHospital: string,
  fazCotacao: boolean,
  valorUnitario: number,
  codificacaoOpmeHospital: {
    hisIdCompra?: string;
    hisIdConsignado?: string;
    hisIdSap?: string;
    valor?: string;
    hospitalId: string;
    id: string;
  }
}

export interface StatusPreAnestesico {
  key: PreAnestesicoEnum | null,
  display: string | null,
}

export interface TemplateHospital {
  hospital: string,
}

export interface Laudo {
  id: string,
  identifier: string,
  name: string,
  tipoDocumento: TipoDocumentoUpload,
  url: string,
  createdBy: string,
  createdByName: string,
  createdOn: string,
  nomeArquivo: string,
  nomeOriginalArquivo: string
}

export interface SolicitacaoResumoResponse {
  id: string,
  nome?: string,
  tipoDocumento: string,
  url?: string,
  versao: number,
  createdOn: string
}

export interface Cid {
  id: string,
  codigo: string,
  descricao: string,
  historicoMedico: boolean,
  histipo?: string,
  display?: string,
}

export interface Procedimento {
  id: string,
  procedimentoPrincipal: boolean | null,
  procedimentoId?: string | null,
  quantidade: number,
  codigo: string | null,
  descricao: string | null,
  historicoMedico: boolean | null,
  porte: string | null,
  lateralidade?: string | { diplay: string, key: string },
  temLateralidade?: boolean,
  quantidadeAutorizada: number,
  hide?: boolean,
  procedimentoConvenio?: string,
  observacaoDaAutorizacao?: string | null,
  coberturaVigente?: boolean,
  tecnicaDoProcedimentoId?: string,
  tecnicaDoProcedimento?: { id: string, descricao: string },
  tecnicaDaCirurgia?: Array<{ id: string, descricao: string }>,
  tecnicasDoProcedimento?: Array<{ id: string, descricao: string }>,
  tempoCirurgicoMinimoEmMinutos?: number,
  particular: boolean,
}

export interface ProtocoloOPME {
  position: number,
  protocoloId: string,
  protocolo: boolean,
  agrupamento: string,
  opmes: OPME[]
}

export interface OPME {
  solicitacaoId: string | null,
  medicoId: string | null,
  codigo: string,
  id: string | null,
  justificativa: string,
  historicoMedico: boolean | null,
  historicoId: string | null,
  quantidade: number | null,
  termo: string,
  fornecedores: Fornecedor[] | null,
  agrupamento: string | null,
  protocoloId: string | null,
  protocolo: boolean,
  mensagem: string,
  termoMensagem: string,
}

export interface OpmePostResponse {
  id: string,
  solicitacaoId: string,
}

export interface Fornecedor {
  fornecedorId: string;
  nome: string;
  opcao: number;
  descricao: string;
  fabricante: string,
  disabled: boolean,
}

export interface NovoFornecedor {
  nomeFornecedor: string,
  nomeFabricante: string,
  medicoId: string,
  hospitalId: string,
  contato: string,
}

export interface Equipamento {
  id: string,
  nome: string | null,
  status: string | null,
  quantidade: number,
  grupoEquipamentoId?: string,
}

export interface EquipamentoGrupoDaSolicitacao {
  id: string;
  nome: string;
  status: string;
  equipamentos: EquipamentoGrupoChild[];
  equipamentSelected?: EquipamentoGrupoChild;
}

export interface EquipamentoGrupo {
  grupoEquipamento: {
    id: string;
    nome: string;
    status: string;
  };
  equipamentos: EquipamentoGrupoChild[];
  equipamentSelected?: EquipamentoGrupoChild;
  hasEmphasis: boolean;
  isSelected?: boolean;
}

export interface EquipamentoGrupoChild extends Equipamento {
}

export interface ExamesIntraOperatorio {
  anatomiaPatologica: boolean,
  anatomiaPatologicaHospitalOuParticular: string | null,
  anatomiaPatologicaParticularLocal: string | null,
  biobanco: boolean,
  broncoscopiaFlexivel: boolean,
  biopsia: boolean,
  biopsiaHospitalOuParticular: string | null,
  biopsiaParticularLocal: string | null,
  catho: boolean,
  cellSaver: boolean,
  colangiografia: boolean,
  colangiopancreatografiaRetrograda: boolean,
  colonoscopia: boolean,
  congelacaoIPC: boolean,
  congelacaoMultipat: boolean,
  congelacaoPathos: boolean,
  congelacaoFerdinando: boolean,
  congelacaoSalomao: boolean,
  congelacaoLoccus: boolean,
  congelacaoFleury: boolean,
  congelacaoEinstein: boolean,
  congelacaoBML: boolean,
  congelacaoCIPAC: boolean,
  congelacaoPathology: boolean,
  dimen: boolean,
  ecocardiograma: boolean,
  ecointraoperatório: boolean,
  ecotransesofagico: boolean,
  endoscopia: boolean,
  escleraUnicamp: boolean,
  examesLaboratoriais: boolean,
  fivmed: boolean,
  insite: boolean,
  mamografia: boolean,
  medicinaNuclear: boolean,
  monitorizacaoNeurofisiologica: boolean,
  nervoNIM: boolean,
  neuronavegacao: boolean,
  outros: boolean,
  outrosEspecificar: string | null,
  potencialEvocado: boolean,
  pth: boolean,
  radioterapia: boolean,
  ressonancia: boolean,
  rxScopia: boolean,
  semExameIntraoperatorio: boolean,
  tipagemSanguinea: boolean,
  tomografia: boolean,
  tomografiaParaEstereotaxia: boolean,
  transporte: boolean,
  udo: boolean,
  ultrassonografiaDeImagem: boolean,
  ultrassonografiaIntraoperatoria: boolean,
  ultrassonografiaIntraoperatoriaEquipeDoHospital: boolean | null,
  ultrassonografiaLaparoscopio: boolean,
  ultrassonografiaRadiologia: boolean,
  ultrassonografiaRadiologiaAcompanhamento: boolean,
}

export interface AnestesistaHospital {
  id: string,
  nome: string,
  crm?: string,
  cpf?: string,
  hisId?: string,
  status?: 'Ativo' | 'Removido',
  temVinculoHospital: boolean,
  tipo?: string,
  hospitais?: {
    anestesistaEstaIntegradoComOHospital?: boolean,
    anestesistaId?: string,
    createdBy?: string,
    createdOn?: string,
    hisId?: string,
    hospitalId?: string,
    status?: 'Ativo' | 'Removido',
    updatedBy?: string,
    updatedOn?: string,
  }[],
}

export interface ReservaHemocomponente {
  concentradoHemacias: { value: boolean, quantidade: number | null },
  concentradoPlaquetas: { value: boolean, quantidade: number | null },
  plasmaFrescoCongelado: { value: boolean, quantidade: number | null },
  crioprecipitado: { value: boolean, quantidade: number | null },
  tipagemSanguinea: { value: boolean, quantidade?: number | null },
  tipagemSanguineaABORHPAI: { value: boolean, quantidade: number | null },
  semReserva: { value: boolean, quantidade?: number | null },
}

export interface Convenio {
  id: string,
  nome: string,
  particular: boolean,
  status: string,
  convenioUtilizaFluxoDePreviaCirurgica: boolean,
  prazoEmDiasParaTriagem: number,
  prazoMaximoEmDiasParaAgendamento: number,
  prazoEmDiasParaSolicitarCirurgiaComOpme?: number,
  prazoEmDiasParaSolicitarCirurgiaSemOpme?: number,
  autorizadorTipo? : 'Totvs',
}

export interface Plano {
  convenioId: string,
  id: string,
  nome: string,
  status: string,
}

export interface Hemocomponente {
  quantidade: number,
  tipo: string,
  solicitacaoId: string,
}

export interface Carater {
  display: string,
  key: string,
}

export interface Etapa {
  display: string,
  key: string,
}

export interface Situacao {
  display: string,
  key: string,
}

export interface SituacaoData {
  display: string,
  key: string,
}

export interface Tipo {
  display: string,
  key: string,
}

export interface DataAutorizada {
  data: string,
  hora: string,
}

export interface ErrorMessage {
  success: boolean,
  total: number,
  errorPaciente: string,
  errorDataNascimento: string,
  errorTelefone: string,
  errorCelular: string,
  errorConvenio: string,
  errorPlano: string,
  errorCarteirinha: string,
  errorCarater: string,
  errorTipoProcedimento: string,
  errorLateralidade: string,
  errorAlergiaLatex: string,
  errorOutrasAlergias?: string,
  errorviasAereasDificilAcesso?: string,
  errorEspecificarAlergia: string,
  errorPrecaucoes: string,
  errorEspecificarPrecaucoes: string,
  errorMedicamentosEspeciaisDescricao: string,
  errorPrevisaoUsoQuimioterapicoDescricao: string,
  errorTempoCirurgia: string,
  errorDiarias: string,
  errorHonorarioMedico: string,
  errorEquipeDoHospital: string,
  errorReservaUti: string,
  errorConcentradoHemaciasQnt: string,
  errorConcentradoPlaquetasQnt: string,
  errorPlasmaFrescoCongeladoQnt: string,
  errorCrioprecipitadoQnt: string,
  errorDiagnosticoJustificativa: string,
  errorCids: string,
  errorProcedimento: string,
  errorOPME: string,
  errorOpmeQuantidade: string,
  errorOpmeFornecedor1: string,
  errorEquipamento: string,
  errorEmail: string,
  errorReservaHemocomponentes: string,
  errorDataPrevista1: string,
  errorDataPrevista2: string,
  errorDataPrevista3: string,
  errorEspecificacaoExameIntraOperatorio: string,
  errorAnestesistaHospital: string,
  errorQuimioterapico: string,
  errorMedicamentosEspeciais: string,
  errorRecemNascido: string,
  errorSexo: string,
  errorTipoAnestesia: string,
  errorTipoAnestesiaPaciente?: string,
  errorpre?: string,
  errorApto?: string,
  errorOrigem?: string,
  errorObservacaoPreAnestesicas?: string,
  errorOutrosTipoAnestesia?: string,
  errorPacienteUsaMarcaPasso?: string,
  errorNomeAnestesista?: string,
  errorAnestesistaCrm?: string,
  errorExamesIntraOperatorios?: string,
}

export interface AgendamentoMedico {
  id: string,
  carater: Carater | null,
  etapa: Etapa | null,
  paciente: string | null,
  procedimento: string | null,
  situacao: Situacao,
  situacaoData: SituacaoData | null,
  configuracoes: {
    prazoEmDiasParaTriagem: number,
    prazoMaximoEmDiasParaAgendamento: number,
  },
  hospitalId: string,
  hospital: string,
  template: string,
  dataAgendamento: string,
  dataAgendamentoVirtual: boolean | null,
  nomeCirurgia?: string,
  nomeMedico: string,
  numeroAgendamento: string,
  protocoloOperadora: string,
  dataAutorizada: {
    data: string,
    hora: string,
  }
  aprovacoesSolicitacao: AprovacoesSolicitacao[],
  acoes: Acoes,
  canceladoMotivo: CanceladoMotivo,
  url: string,
  urlNaoParticular: string,
  tempoCirurgia: number,
  statusCirurgia: StatusCirurgiaEnum | null,
  medicoSolicitanteId: string,
  localAtendimentoId: string,
  convenioNome: string,
  autorizacaoValidade: string,
  autorizacaoObservacao: string,
  segueOProtocolo?: StatusDoProtocoloEnum
  convenioId?: string,
  dataSolicitacao?: string,
  createdOn?: string,
  dataValidadeOrcamentoParticularAvulso?: string,

  // Chat flags
  solicitacaoChatTotalMensagensNaoLidas?: number,
  solicitacaoChatFinalizado?: boolean,
  hospitalUtilizaChat?: boolean,
  laudos: Laudo[],
  orcamentoParticular?: string,
  valorOrcamentoParticular?: number,
  temOpme: boolean
}

export interface CanceladoMotivo {
  display: string,
  key: string,
}

export interface Acoes {
  editar: boolean,
  podeResolverPendencia: boolean,
  aceitarAutorizacaoParcial: boolean,
  criarContestacao: boolean,
  responderContestacao: boolean,
  visualizarContestacao: boolean,
  visualizarItensAutorizados: boolean,
  agendamentoRealizaTriagem: boolean,
  agendamentoAtualizaTriagem: boolean,
  visualizar: boolean,
  fidelizacaoFazAnaliseDeProtocoloNaoAderente?: boolean,
  analizarResposta: boolean,
  contatar: boolean,
  confirmarData: boolean,
  alterarData: boolean,
  autorizacaoFazCotacao: boolean,
  autorizacaoFazAnalisePosCotacao: boolean,
  autorizacaoResolvePendenciaRoboAutorizacao: boolean,
  autorizacaoAutorizar: boolean,
  autorizacaoFazAnalisePreAutorizacaoUrgencia: boolean,
  autorizacaoFazAnalisePreAutorizacao: boolean,
  autorizacaoFazAnalisePreCotacao: boolean,
  autorizacaoEvoluiAguardandoPrazoPosTriagem: boolean,
  agendamentoConfirmaCancelamento: boolean,
  visualizarPendencia: boolean,
  agendamentoFazCancelamento: boolean,
  anestesistaFazAvaliacao: boolean,
  autorizacaoAlteraCotacao: boolean,
  abrePendenciaAdministrativa?: boolean,
  agendamentoResolvePendenciaAdministrativa?: boolean,
  autorizacaoFazRetornoParaCotacao: boolean,
  orcamentoEnviaOrcamento?: boolean,
  autorizacaoAutorizaNegociacaoParticular: boolean,
  agendamentoFazReservaDeSalaParticular: boolean,
  autorizacaoSolicitaCancelamento?: boolean,
  agendamentoInformaReservaEmSolicitacaoParticular: boolean,
  podeAtualizarStatus?: boolean,
  podeVisualizarStatus?: boolean,
  podeAtualizarDataAgendamento?: boolean,
  podeVisualizarModalAtualizarDataAgendamento?: boolean,
  podeAtualizarItensAutorizados?: boolean,
  clinicaFazCancelamentoDaSolicitacao?: boolean,
  medicoCancelaSolicitacao?: boolean,
  solicitarCancelamento: boolean,
  podeInformarCirurgiaComoRealizada?: boolean,
  podeInformarCirurgiaComoNaoRealizada?: boolean,
  podeDesfazerCancelamento?: boolean,
  podeAlterarOrigemDoPaciente?: boolean,
  podeExcluirSolicitacaoDeCirurgia?: boolean,
  podeAssinarEEnviarQuandoDisponivelParaEnvio?: boolean,
  podeUsarOrcamentoParticularAvulsoComoSolicitacaoModelo?: boolean,
  podeAplicarCirurgiaModelo?: boolean,
  alterarMedicoSolicitante?: boolean,
  regulacaoEnviaParaFidelizacao?: boolean,
  regulacaoFazAnaliseDeProtocolo?: boolean,
  medicoFinalizaSolicitacaoQuandoAutorizadoPeloAutorizador?: boolean,
  permiteGerarGuiaTISS?: boolean,
}

export interface Medico {
  id: string,
  nome: string,
  urlAssinatura: string
}

export interface MedicoDoHis {
  hisId: string,
  nome: string,
  cpf: string,
  crm: string,
  dataDesligamento: Date | string | null,
}

export interface Hospital {
  id: string,
  nome: string,
  urlAssinatura?: string,
  integracaoOperadora?: {
    id: string,
    nome: string,
    status: {
      key: string,
      display: string,
    },
  },
  dataGoLiveIntegracaoHis?: Date | string | null,
  dataVirtualFazReservaDeSala?: boolean,
  exigeNumeroReserva?: boolean,
  fazReservaDeSala?: boolean,
  hisTipo?: string,
  hospitalInsereProcedimentosDeInternacao?: boolean,
  hospitalSolicitaAlterarReservaNoMapaCirurgico?: boolean,
  hospitalUtilizaChat?: boolean,
  hospitalFazOrcamentoParticularAvulso?: boolean,
  hospitalDataVirtualFazReservaDeSala?: boolean,
  hospitalInformaMotivoDeTransferenciaReserva?: boolean,
  usaProcedimentosApenasHospitalDia?: boolean,
  alterarMedicoSolicitante?: boolean,
  utilizaAnalisePreAutorizacaoUrgencia?: boolean,
  utilizaAguardandoAutorizacaoUrgencia?: boolean,
  utilizaTipoAcomodacaoHospital?: boolean,
  hospitalPossuiTermoDeUso?: boolean,
  hospitalIntegraComAutorizadorAntesDaReserva?: boolean,
  termoDeUsoAceitoPeloUsuario?: boolean,
  hospitalInformaMotivoDeRecusaDoOrcamento?: boolean,
}

export interface OperadoraBackoffice {
  id: string,
  nome: string,
  registroAns: string,
}

export interface MedicoSolicitante {
  conselhoTipo: 'CRM' | 'CRO',
  conselhoNumero: string,
  conselhoUf: string,
  cpf: string,
  especialidade: string,
  hospitais: string[],
  medicoTemUsuario: boolean | null,
  recebeEmailNotificacao: boolean | null,
  email: string,
  id: string,
  nome: string,
  urlAssinatura: string,
  telefone: string,
  assinatura?: string,
}

export interface SecretariaDoMedicoSolicitante {
  nome: string,
  telefone: string,
  email: string,
}

export interface ItemAutorizado {
  status: {
    key: string,
    display: string
  },
  anexos?: Laudo[],
  justificativa?: string,
}

export interface MotivoCancelamento {
  status: {
    key: string,
    display: string,
  },
  canceladoMotivo: {
    key: string,
    display: string,
  },
  anexos?: Laudo[],
  justificativa?: string,
}

export interface SolicitacaoQueryString {
  medicoSolicitanteId?: string,
  isInstrumentador?: boolean,
  orderBy: string,
  pagina?: number,
  qtdPorPagina?: number,
  pacienteNome?: string,
  solicitacaoSituacao?: string[],
  solicitacaoSituacaoData?: string,
  solicitacaoHospital?: string[],
  dataAgendamentoInicio?: string,
  dataAgendamentoFim?: string,
  caraterCirurgia?: string,
}

export interface CentroCirurgico {
  id: string,
  nome: string,
  hospital: {
    nome: string
  }
}

export interface HonorarioAnestesista {
  display: string,
  key: string
}

export interface MotivoRecusaDoOrcamento {
  id?: string,
  descricao: string,
  hospitalId: string,
  status: 'Ativo' | 'Removido',
}
